import View from "./view.js";
import WebMercatorViewport from "../viewports/web-mercator-viewport.js";
import MapController from "../controllers/map-controller.js";
class MapView extends View {
    constructor(props = {}) {
        super(props);
    }
    get ViewportType() {
        return WebMercatorViewport;
    }
    get ControllerType() {
        return MapController;
    }
}
MapView.displayName = 'MapView';
export default MapView;
